export const classes = {
  overlayProvider: 'OverlayProvider',
};
